import React from 'react'
import './Banniere.css'

// On importe des variables du fichier variables.js
import {
    listClubProam,
    listClubProad,
    listClubProbm,
    listClubProbd,
} from '../variables.js'

// On importe le logo
import logo from '../assets/logo_pro.jpg'

// On importe les components
import { useNavigate } from 'react-router-dom';
import LogoClub from './LogoClub';


function Banniere() {
    const navigate = useNavigate(); // On importe la fonction pour changer de route
    const SIZE_CLUB = "46";

    return ( 
        <div className="banniere_component">
            <div className="banniere_ban">
                <img src={logo} alt="Logo pro" onClick={()=>navigate('/')} className="logo_nav" />
                {/* Logo de la navbar */}
                <div className="banniere_logo">
                    {/* <img src={logo} alt="Logo pro" onClick={()=>navigate('/')} style={{cursor: 'pointer'}} /> */}
                    {/* <span>
                        Sites <br /> 
                        officiels <br />
                        des clubs
                    </span> */}
                    {/* <a 
                        href= "https://www.flickr.com/photos/196361087@N07" 
                        // style={{position: "absolute", top: 165, left: 1700}}
                        target="blank_"
                    >
                        <img src={flickr} alt="" 
                            style={{cursor: 'pointer', width: 32}} 
                        />
                    </a> */}
                </div>
                {/* Liste des logos */}
                <div className="banniere_logo_clubs" 
                >
                    {/* Affichage des clubs de la PROAM */}
                    <div className="slider-track" style={{display: 'flex', width: '100%'}}>
                        {
                            [listClubProam, listClubProbm, listClubProad, listClubProbd].map((liste) =>
                                liste.map((item) => (
                                    <div className="slide" key={item.id} style={{ padding: 10, paddingTop: 0, paddingBottom: 0 }}>
                                        <LogoClub club={item} width={SIZE_CLUB} height={SIZE_CLUB} />
                                    </div>
                                ))
                            )
                        }
                        {
                            [listClubProam, listClubProbm, listClubProad, listClubProbd].map((liste) =>
                                liste.map((item) => (
                                    <div className="slide" key={item.id} style={{ padding: 10, paddingTop: 0, paddingBottom: 0 }}>
                                        <LogoClub club={item} width={SIZE_CLUB} height={SIZE_CLUB} />
                                    </div>
                                ))
                            )
                        }
                    </div>
                    
                    {/* Affichage des clubs de la PROAD */}
                   
                </div>
            </div>
        </div> 
    );
}

export default Banniere;
